import { Fragment } from 'react';

interface ICommunicationMessageProps {
  message: string | null | undefined;
}

/**
 * Componente centralizzato per la visualizzazione del messaggio di una comunicazione
 * nella lista delle comunicazioni (standard/tabella).
 *
 * Per ora il messaggio è semplicemente una stringa di testo, ma può contenere gli a capo,
 * quindi la visualizziamo con i <br />.
 */
export function CommunicationMessage(props: ICommunicationMessageProps) {
  const { message } = props;

  if (!message) return null;

  return message.split('\n').map((m, index) => (
    <Fragment key={index}>
      {m}
      <br />
    </Fragment>
  ));
}
